/**
 * Règle de robustesse des mots de passe saisis par l'utilisateur :
 * au moins 8 caractères, une majuscule, un chiffre et un caractère spécial.
 *
 * Doit rester identique à la contrainte back
 * App\Validator\Constraints\User\PasswordRequirements (reseau-pro-back).
 */
export const PASSWORD_MIN_LENGTH = 8;

// Regex unicode : « É » compte comme majuscule, et tout ce qui n'est ni lettre ni chiffre
// (ponctuation, symbole, espace) compte comme caractère spécial. Identique au back.
export const PASSWORD_REGEX = /^(?=.*\p{Lu})(?=.*\d)(?=.*[^\p{L}\p{N}]).{8,}$/u;

export const PASSWORD_HELP =
  "Choisissez un mot de passe d’au moins 8 caractères avec une majuscule, un chiffre et un caractère spécial.";

/**
 * Règles react-hook-form du champ mot de passe.
 *
 * @param {boolean} required - false pour un champ facultatif (modification de profil : laisser
 *                             vide signifie « ne pas changer le mot de passe »)
 * @returns {Object} règles à passer à `rules` / `register`
 */
export function passwordRules(required = true) {
  if (!required) {
    // Champ facultatif : la règle ne s'applique qu'à une valeur non vide.
    return {
      validate: (value) => !value || PASSWORD_REGEX.test(value) || PASSWORD_HELP,
    };
  }

  return {
    required: "Mot de passe requis",
    minLength: { value: PASSWORD_MIN_LENGTH, message: PASSWORD_HELP },
    pattern: { value: PASSWORD_REGEX, message: PASSWORD_HELP },
  };
}
